import { createEffect } from "solid-js";
import { useAuthV2 } from "@/domains/auth/context/auth-provider";
import { useGetCompanyMembers } from "@/domains/company/company/api";
import {
  useCompanyActions,
  useCompanyStore,
} from "@/domains/company/company/store/company-store";

/**
 * Hydrates `currentMemberRole` in the company store by matching the active
 * profile against the company members list. Runs whenever the selected
 * company or the authenticated profile changes.
 */
export const useHydrateCurrentMemberRole = () => {
  const [companyStore] = useCompanyStore();
  const { setCurrentMemberRole } = useCompanyActions();
  const [authStore] = useAuthV2();

  const members = useGetCompanyMembers(
    () => companyStore.selectedCompany?.id ?? "",
  );

  createEffect(() => {
    const profileId = authStore.profile?.id;
    const companyId = companyStore.selectedCompany?.id;
    if (!profileId || !companyId) {
      setCurrentMemberRole(null);
      return;
    }
    if (companyStore.selectedCompany?.role) {
      setCurrentMemberRole(companyStore.selectedCompany.role);
      return;
    }
    const list = members.data?.members;
    if (!list) return;
    const me = list.find((m) => m.profile_id === profileId);
    setCurrentMemberRole(me?.role ?? null);
  });
};
